<script setup lang="ts">
import type { Tables } from '~~/types/database.types.ts';
const props = defineProps<{
  creator: Tables<'profiles'>;
}>();
</script>

<template>
  <NuxtLinkLocale :to="`/@${props.creator.mappr_handle}`" class="creatortag-container">
    <MPImg
      class="profile-image"
      :src="props.creator.profile_image_url"
      :width="40"
      :height="40"
    />
    <div class="creatortag-name">
      Map by: @{{ props.creator.mappr_handle }}
    </div>
  </NuxtLinkLocale>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/typography.pcss";
.creatortag-container {
  display: flex;
  background-color: var(--color-indigo-500);
  border-radius: 10rem;
  align-items: center;
  width: fit-content;
  padding-right: 1rem;

  .profile-image {
    border-radius: 100%;
    border: 5px solid var(--color-indigo-600);
    width: 2.25rem;
    height: 2.25rem;
  }

  .creatortag-name {
    padding: 0 1.5rem 0 1rem;
    line-height: 0;
    white-space: nowrap;
    @mixin typeface-regular;
    color: var(--color-white)
  }
}

</style>
